module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAAEAAAAAC2HIDeAAAAiklEQVQoFY2SQRKAIAhFrV2LOlUdtLYdrXW2rO8ERoCWMwzI/MfXMpz3mpH68GcREJE3xPjJEMBpR7Egym6sFJndJtdNCHXpu2mV2ls3JShts1uTFO5ZbfNAq2ttv975C0SMWRFDKB2a+nzp54dWgHRR+2QcwE6V11JA/nxS86oJqE+VBAH1ByeACwb8Xu0w2sE8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/play-white.png
// module id = l+uX
// module chunks = 1